import {Decoder, field, object, string} from 'json-bouncer'
import {nullableWithDefaultDecoder} from '../Data/DecodeHelper'
import {Order} from './Order'

export interface OrderGeneralInformation {
    readonly vatId: string | null
}

export function orderGeneralInfoDecoder(): Decoder<OrderGeneralInformation> {
    return object({
        vatId: field('vatId', nullableWithDefaultDecoder('', string()))
    })
}

export function fromOrder({vatId}: Order): OrderGeneralInformation {
    return {vatId}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/OrderGeneralInformation.ts